module.exports = __webpack_public_path__ + "img/made-in-france.1c6ffe9e.png";